import { render, staticRenderFns } from "./SearchboxHotel.vue?vue&type=template&id=b72d6bf8"
import script from "./SearchboxHotel.vue?vue&type=script&lang=js"
export * from "./SearchboxHotel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports